import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { TeachersCreatePage } from '../teachers-create/teachers-create';
import { TeachersViewPage } from '../teachers-view/teachers-view';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-teachers-list',
  templateUrl: 'teachers-list.html',
})
export class TeachersListPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public http: HttpClient,
    public schoolServices: SchoolServices,
    public translate: TranslateService) {

  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-profesores')
    });
    loadingPopup.present();
    this.schoolServices.getTeachers(this.globals.school_uid);
    loadingPopup.dismiss();

  }

  onBack() {
    this.navCtrl.pop();
  }

  openTeacherCreate() {
    this.navCtrl.push(TeachersCreatePage);
  }

  openTeacher(teacher) {
    this.navCtrl.push(TeachersViewPage, {
      teacher: teacher,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/schools/teachers-list/teachers-list.ts